import { VehicleMediaData } from 'types';

/**
 * Checks which images are available on their URL and can be loaded. Images which return a 404 are filtered out.
 * The availability of the image is checked indirectly by using an Image elements instead of using the fetch API.
 * This is to circumvent errors about missing CORS headers.
 * @param {VehicleMediaData[]} exteriorImages - Array of exterior VehicleMediaData objects
 * @param {VehicleMediaData[]} interiorImages - Array of interior VehicleMediaData objects
 * @returns {Promise<[VehicleMediaData[]]>} - A Promise that resolves with an array of available images
 * including the working interior and extorior images
 */
export const getAvailableImages = (images: VehicleMediaData[]): Promise<VehicleMediaData[]> => {
	if (images.length === 0) {
		return Promise.resolve([]);
	}

	return new Promise((resolve) => {
		let workingImages: VehicleMediaData[] = images;
		let numChecked = 0;

		const checkImage = (image: VehicleMediaData) => {
			const occasionImg = new Image();
			occasionImg.src = image.url;

			const loadEventHandler = () => {
				numChecked += 1;
				occasionImg.removeEventListener('load', loadEventHandler);

				if (numChecked === images.length) {
					resolve(workingImages);
				}
			};

			occasionImg.addEventListener('load', loadEventHandler);

			const errorEventHandler = () => {
				numChecked += 1;
				workingImages = workingImages.filter((img) => img !== image);

				occasionImg.removeEventListener('load', errorEventHandler);
				if (numChecked === images.length) {
					resolve(workingImages);
				}
			};

			occasionImg.addEventListener('error', errorEventHandler);
		};

		images.forEach((img) => {
			checkImage(img);
		});
	});
};
